import { PassportOffer } from '../components/PassportOffer';

const RemoveAdsRoute = () => <PassportOffer />;

export default RemoveAdsRoute;
